import mutations from "@/store/mutations/backUpAppMutation";
import actions from "@/store/actions/backUpAppAction";
import getters from "@/store/getters/backUpAppGetter";
/**
 * [GX] back up app
 */
export default {
  state: {
    backUpAppShowEnable: false, //条件是否达到开启的基本条件
    backUpAppConfigInterfaceEnable: null, //拉取的配置的原生接口是否可用
    backUpAppWayInterfaceEnable: null, //
    backUpAppConfig: null, //backup app的原生pinad配置
    backUpAppInstalled: null //是否安装过backup app
  },
  mutations,
  actions,
  getters
};
